/**
 * PG사(토스페이먼츠 / KG이니시스) 가맹점 심사 시 판매 페이지에 필수로 노출되어야 하는 사업자 정보.
 *
 * [PG 심사 필수 표기 항목 - 전자상거래법 제10조, 통신판매업 신고 기준]
 *  - 상호명 / 대표자명
 *  - 사업자등록번호
 *  - 통신판매업 신고번호 (미신고 — 신고 후 추가. 없어도 국민카드 외 카드사 심사는 진행 가능)
 *  - 사업장 주소
 *  - 고객센터 연락처(전화, 이메일)
 *
 * 표시 위치: 메인 웹 전 페이지 푸터 아래 띠(스크롤 시 노출) + 스토어 푸터. 공통 컴포넌트 `components/business-info`.
 */
export const STORE_BUSINESS_INFO = {
  companyName: "(주)에스알파테라퓨틱스",
  ceoName: "최헌",
  businessRegistrationNumber: "477-81-01590",
  address: "서울특별시 영등포구 양산로 91, 607호,608호(당산동3가, 리드원센터)",
  customerServicePhone: "02-3487-3921",
  customerServiceEmail: "support@salphadtx.com",
  customerServiceHours: "평일 10:00 ~ 18:00 (주말/공휴일 휴무)",
} as const;
